import resume from "../assets/pdf/resume.pdf";

export const headerData = {
  name: "Abdul Rafay",
  title: "App Developer",
  desciption:
    "A passionate individual with strong collaborative and multi-tasking skills looking out for opportunities to build reliable and scalable mobile applications. ",
  image:
    "https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png",
  resumePdf: resume,
};
